export default __webpack_public_path__ + "static/media/Blog5.4a6bc351.jpg";